import router from '@/core/router.js';
import request from '@/utilities/request';
import { SIGNINTYPE, countDown } from '@/utilities/index';

export default {
  sendMFACode({ commit, state }, { method }) {
    commit('setIsCodeSentFail', false);
    window.clearInterval(state.counter);
    commit('setCounter', null);
    commit('setIsCountDowning', true);
    commit('setCoundownSec', 120);

    let counter;

    request
      .post('/signin/module.php/tmauth/mfasendcode', { send_otp_code: method })
      .then(() => {
        counter = countDown(
          120,
          (sec) => {
            commit('setCoundownSec', sec);
          },
          () => {
            commit('setIsCountDowning', false);
          },
        );

        commit('setCounter', counter);
      })
      .catch(() => {
        if (counter) {
          window.clearInterval(counter);
          commit('setCounter', null);
        }

        commit('setIsCountDowning', false);
        commit('setIsCodeSentFail', true);
      });
  },
  verifyMFACode({ commit, state, dispatch, getters }, verifyForm) {
    let postPath = '';
    let code = state.MFACode;

    commit('setIsVerifying', true);
    commit('setMFACodeErr', '');
    dispatch('triggerEvent', { eventName: `VerifyCode-${getters.currentMethod}` }, { root: true });

    if (getters.currentMethod === 'googleauth') postPath = '/signin/module.php/tmauth/mfaverifycodetotp';
    if (getters.currentMethod === 'sms') postPath = '/signin/module.php/tmauth/mfaverifycodesms';
    if (getters.currentMethod === 'email') postPath = '/signin/module.php/tmauth/mfaverifycodeemail';

    request
      .post(postPath, { code })
      .then(() => {
        window.clearInterval(state.counter);
        commit('setCounter', null);
        commit('setIsVerifying', false);
        dispatch(
          'triggerEvent',
          { eventName: `VerifyCodeSuccess-${getters.currentMethod}` },
          { root: true },
        );

        if (state.signInType === SIGNINTYPE.email && getters.needEmailVerification) {
          router.push({ name: 'auth/signInVerifyEmail' });
          return;
        }

        verifyForm.submit();
      })
      .catch(() => {
        commit('setIsVerifying', false);
        dispatch(
          'triggerEvent',
          { eventName: `VerifyCodeNG-${getters.currentMethod}` },
          { root: true },
        );
        commit('setMFACodeErr', state.lang.incorrectCode);
      });
  },
};
